import { FC } from 'react'
import { generatePath, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { ContractNavigationGroup } from './ContractNavigationGroup'
import { ContractNavigationItem } from './ContractNavigationItem'
import styles from './styles.module.scss'
import { Paths } from '@/paths'
import { CardLayout } from '@/components/CardLayout'

export const ContractNavigation: FC = () => {
  const { t } = useTranslation()
  const { contractNumber } = useParams<{ contractNumber: string }>()

  const masterDataPath = generatePath(Paths.CONTRACT_DETAILS_MASTER_DATA, { contractNumber: contractNumber! })
  const tariffBookingsPath = generatePath(Paths.CONTRACT_DETAILS_TARIFF_BOOKINGS, { contractNumber: contractNumber! })

  return (
    <CardLayout>
      <nav className={styles.contractNavigation}>
        <ContractNavigationGroup label={t('contract.navigation.contractAndTariffGroup')}>
          <ContractNavigationItem label={t('contract.navigation.masterData')} to={masterDataPath} />
          <ContractNavigationItem label={t('contract.navigation.tariff')} to={tariffBookingsPath} />
        </ContractNavigationGroup>
      </nav>
    </CardLayout>
  )
}
